import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { BFLoader } from '@components/common/loader/main';
import {
  bulkRefreshSections,
  pluralizeObject
} from '@helpers/show_page_helpers';
import { removeFromLabel } from '@api/v4/bulk_actions/assets';
import renderModal from '../modals/renderModal';

const BulkLabelModal = (props) => {
  const [isLoading, toggleIsLoading] = useState(false);
  const [disableSubmitButton, toggleDisableSubmitButton] = useState(false);

  useEffect(() => (
    () => { props.closeModal(); }
  ), []);

  const {
    activeLabelKey,
    addRemoveSelected,
    closeModal,
    labels,
    selectedAssetKeys
  } = props;

  const activeLabel = labels.labelsFlat[activeLabelKey].name;
  const assetQtyObject = pluralizeObject(selectedAssetKeys);
  const assetCopy = assetQtyObject.plural ? t('assets') : t('asset');
  const loaderActive = isLoading ? 'loader-active' : '';

  const removeLabel = () => {
    toggleIsLoading(true);
    toggleDisableSubmitButton(true);

    removeFromLabel(Array.from(selectedAssetKeys), activeLabelKey)
      .then(() => {
        BF.fx.updateAssetPageCount(assetQtyObject.qty, false);
        bulkRefreshSections(selectedAssetKeys, 1000);
        addRemoveSelected([]);
        closeModal();
        Notify.create({
          title: `${activeLabel} ${t('label removed from')} ${assetQtyObject.qty} ${assetCopy}!`,
          type: 'success'
        });
      })
      .catch(() => {
        toggleIsLoading(false);
        toggleDisableSubmitButton(false);
        Notify.create({
          title: t('An error occurred when removing label. Please try again.'),
          type: 'error'
        });
      });
  };

  return (
    <div className="modal-content-wrapper bulk-label-modal">
      <div className="modal-content-wrapper__header">
        <span className="bff-label icon" aria-hidden="true" />
        <h2 className="modal-title">{t('Remove Label')}</h2>
      </div>
      <div className={`modal-content-wrapper__body ${loaderActive}`}>
        {isLoading
          ? <BFLoader />
          : (
            <div>
              <h3 className="body-title">
                {t('Are you sure you want to remove')}
                <span className="bold-text">{activeLabel}</span>
                {t('label from')}
                <span className="bold-text">{`${selectedAssetKeys.size} ${assetCopy}?`}</span>
              </h3>
              <div className="button-container">
                <button
                  className="button tertiary sm t-close-modal"
                  onClick={closeModal}
                  type="button"
                >
                  {t('Cancel')}
                </button>
                <button
                  className="button sm warning t-confirm-modal"
                  disabled={disableSubmitButton}
                  onClick={removeLabel}
                  type="button"
                >
                  {t('Remove')}
                </button>
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
};

BulkLabelModal.propTypes = {
  activeLabelKey: PropTypes.string.isRequired,
  addRemoveSelected: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  labels: PropTypes.shape({}),
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
};

BulkLabelModal.defaultProps = {
  labels: {},
};

const ModalComponent = renderModal(BulkLabelModal, 'BulkLabelModal');
export default ModalComponent;
